'use client';

/**
 * Registers the push-only Service Worker once, inside the authenticated
 * admin shell. Mounted here (not globally) so only logged-in owners get a
 * SW — the marketing site stays SW-free.
 *
 * `updateViaCache: 'none'` ensures the browser never serves a stale SW
 * script from HTTP cache, so a new deploy's SW activates on next navigation.
 * Renders nothing.
 */

import { useEffect } from 'react';

export function PWARegistrar() {
  useEffect(() => {
    if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;
    navigator.serviceWorker
      .register('/sw.js', { updateViaCache: 'none' })
      .catch(() => {
        // Non-fatal: push just stays unavailable. Never surface to the user.
      });
  }, []);

  return null;
}
